// extracted by mini-css-extract-plugin
module.exports = {"dragndropContainer":"style_dragndropContainer__3sPHe"};